const { PanelBody, PanelRow, Button, __experimentalNumberControl: NumberControl, TextControl, FormToggle, SelectControl, TextareaControl, ButtonGroup, __experimentalUnitControl: UnitControl } = wp.components;
const { __ } = wp.i18n;

import BMediaUpload from "../../BMediaUpload";

const Subtitle = ({ setAttributes, attributes }) => {
  const { captionEnabled, subtitle } = attributes;

  const handleSubtitle = (property, value, index) => {
    const newSubtitle = [...subtitle];
    newSubtitle[index] = { ...newSubtitle[index], [property]: value };
    setAttributes({ subtitle: newSubtitle });
  };

  const removSubtitle = (index) => {
    const newSubtitle = [...subtitle];
    newSubtitle.splice(index, 1);
    setAttributes({ subtitle: newSubtitle });
  };

  return (
    <PanelBody className="subtitlePanel" title={__("Subtitle", "h5vp")} initialOpen={false}>
      {subtitle.map((item, index) => {
        return (
          <PanelBody title={item.label} initialOpen={false} className="subtitleItem">
            <PanelRow className="width-100">
              <TextControl value={item?.label} onChange={(label) => handleSubtitle("label", label, index)} placeholder={"Caption Label"} />
            </PanelRow>
            <BMediaUpload
              // type={["audio/mp3"]}
              onSelect={(source) => handleSubtitle("caption_file", source, index)}
              value={item?.caption_file}
              placeholder="Subtitle File"
            />
            <Button onClick={() => removSubtitle(index)}>{__("Remove", "h5vp")}</Button>
          </PanelBody>
        );
      })}
      <Button
        isPrimary
        onClick={() => {
          setAttributes({ subtitle: [...subtitle, { label: "label" }] });
        }}
      >
        {__("Add More", "h5vp")}
      </Button>
      {subtitle && (
        <PanelRow>
          <label class="label" for="captionEnabled">
            {__("Enable caption by default (Experimental)", "h5vp")}
          </label>
          <FormToggle id="captionEnabled" checked={captionEnabled} onChange={() => setAttributes({ captionEnabled: !captionEnabled })} />
        </PanelRow>
      )}
    </PanelBody>
  );
};

export default Subtitle;
